(() => {
  const root = document.querySelector('.rb-claims');
  const form = root?.querySelector('#RbClaimsForm');
  if (!form || form.dataset.ready) return;
  form.dataset.ready = 'true';
  const result = root.querySelector('#rb-result');
  if (result) result.focus();
  if (root.querySelector('[data-rb-success]')) return;
  const minor = form.querySelector('#rb-minor');
  const guardian = form.querySelector('.rb-guardian');
  const guardianFields = guardian.querySelectorAll('[data-guardian]');
  function updateGuardian() {
    const active = minor.value === 'Sí';
    guardian.hidden = !active;
    guardianFields.forEach(field => { field.disabled = !active; field.required = active; });
  }
  minor.addEventListener('change', updateGuardian);
  updateGuardian();
  const docType = form.querySelector('#rb-doc_type');
  const docNumber = form.querySelector('#rb-doc_number');
  function updateDocument() {
    docNumber.pattern = docType.value === 'DNI' ? '[0-9]{8}' : docType.value === 'RUC' ? '[0-9]{11}' : '[A-Za-z0-9 -]{4,20}';
    docNumber.inputMode = ['DNI', 'RUC'].includes(docType.value) ? 'numeric' : 'text';
  }
  docType.addEventListener('change', updateDocument);
  updateDocument();
  const offline = form.querySelector('[data-rb-offline]');
  const pending = form.querySelector('[data-rb-pending]');
  const uncertain = form.querySelector('[data-rb-uncertain]');
  const button = form.querySelector('[type="submit"]');
  let timer;
  form.addEventListener('submit', event => {
    offline.hidden = true;
    if (!navigator.onLine) {
      event.preventDefault();
      offline.hidden = false;
      offline.tabIndex = -1;
      offline.focus();
      return;
    }
    pending.hidden = false;
    uncertain.hidden = true;
    clearTimeout(timer);
    timer = setTimeout(() => { pending.hidden = true; uncertain.hidden = false; }, 25000);
  });
  window.addEventListener('pageshow', () => { clearTimeout(timer); pending.hidden = true; button.disabled = false; });
})();
